import pl from "./pl"
import en from "./en"
import fr from "./fr"

export default {
    pl,
    en,
    fr
}